'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = require('redux');

var _rootReducer = require('../reducers/rootReducer');

var _rootReducer2 = _interopRequireDefault(_rootReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Configures the Redux store.
 * @returns {Store} The configured Redux store.
 */
exports.default = function () {
  return (0, _redux.createStore)(_rootReducer2.default, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default), process.env.NODE_ENV !== 'production' && window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  }));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/store/configureStore.js
// module id = 1718
// module chunks = 0